// this.$util.nativePie('OPEN_WEBVIEW', {
//   targetUrl: `${process.env.VUE_APP_NICEE_WEB}${path}?isApp=1`,
//   showBack: 1, //0没有返回按键 1返回按键 2代表有返回按钮并且非全屏
//   title: '' //标题
// background: '', //背景
// color: '' //文字颜色
// targetType,: 1 // 1是第三方url,不传是我们自己的url
// });
// SHOW_RETRY_VIEW //重试

// 切換tab party、message、quick_order、home、mine
// this.$util.nativePie('SWITCH_TAB', {
//   tabName: 'party',
//   isMainPage: 1
// });

//浏览器打开
//  this.$util.nativePie('OPEN_MOBILE_BROWSER', {
//         targetUrl: this.link
//  });

import onVersion from './version'
import router from '@/router'

const canUseCallback = onVersion('1.22.0')
const paramsPreHandle = {
  OPEN_WEBVIEW,
  LOG_EVENT
}

if (canUseCallback) {
  var callbackMap = {}
  var callbackId = 0

  // 收集callback
  var saveCallback = function () {
    let cbP
    const p = new Promise((resolve, reject) => {
      cbP = { resolve, reject }
    })
    const thenFn = p.then
    callbackId++
    p.then = function (callback, error) {
      callbackMap[callbackId] = cbP
      return thenFn.call(p, callback, error)
    }
    return p
  }

  // 客戶端回調函數
  window.nativeCallback = (callbackId, error, success) => {
    if (!callbackMap[callbackId]) return
    let rs = error || success
    if (typeof rs === 'string' && rs[0] === '{') {
      rs = JSON.parse(rs)
    }
    if (error) {
      callbackMap[callbackId].reject(rs)
    } else {
      callbackMap[callbackId].resolve(rs)
    }
    delete callbackMap[callbackId]
  }
}
/**
 * @description: 记录前一个页面
 * @param {*} params
 * @return {*}
 */
function OPEN_WEBVIEW(params) {
  if (typeof params !== 'object' || !params) return params
  let targetUrl = params.targetUrl || ''
  const hasQuery = ~targetUrl.indexOf('?')
  const currentRoute = router.history.current
  let preTag = `prepage=${currentRoute.name}`
  preTag = hasQuery ? '&' + preTag : '?' + preTag
  targetUrl = targetUrl + preTag
  const prePageInfo = {
    prePage: currentRoute.fullPath,
    preRouterName: currentRoute.name,
    firstPage: router.match(targetUrl).name
  }
  localStorage.setItem('prepage', JSON.stringify(prePageInfo))
  params.targetUrl = targetUrl
  return params
}
/**
 * @description: 打点增加公共参数
 * @param {*}
 * @return {*}
 */
function LOG_EVENT(eventParams) {
  if (typeof eventParams !== 'object' || !eventParams) return eventParams
  const params = eventParams.params || {}
  const prePageInfo = router.prePageInfo || {}
  params.pre_page = prePageInfo.preRouterName
  params.pre_path = prePageInfo.prePage
  eventParams.params = params
  console.warn('event:', params)
  return eventParams
}
/**
 * @description: 調用原生方法
 * @param {*} method
 * @param {*} params
 * @return {*}
 */
export default function(method, params = '') {
  if (!method) {
    throw new Error('未传入method-name')
  }
  if (paramsPreHandle[method]) {
    params = paramsPreHandle[method](params)
  }
  if (window.location.port) {
    // 在本地开发环境，兼容处理一些native方法
    if (method === 'GO_BACK') {
      // native后退
      router.back()
    } else if (method === 'OPEN_WEBVIEW' && params.targetUrl) {
      // native打開新webview
      router.push(params.targetUrl)
    }
    console.warn(`trigger method: ${method}`)
    return Promise.resolve()
  }
  let p
  let jsonStr = params
  const isObj = typeof params === 'object'
  if (canUseCallback) p = saveCallback()
  if (this.isiOS) {
    if (canUseCallback) {
      if (params && isObj) {
        params.callbackId = callbackId
        jsonStr = { ...params }
        for (const item in params.params) {
          if (typeof params.params[item] === 'string') continue
          jsonStr.params[item] = JSON.stringify(params.params[item])
        }
        jsonStr = JSON.stringify(jsonStr)
      } else {
        if (params) {
          console.warn('adjust传参存在type !== object')
        }
      }
    } else {
      isObj && (jsonStr = JSON.stringify(params));
    }
    try {
      window.webkit.messageHandlers[method].postMessage(jsonStr)
    } catch (e) {
      return Promise.reject(e)
    }
  } else {
    if (canUseCallback) {
      if (isObj) {
        if (params) {
          params.callbackId = callbackId;
          jsonStr = JSON.stringify(params);
        } else {
          jsonStr = JSON.stringify({
            callbackId
          })
        }
      } else {
        jsonStr = JSON.stringify({
          callbackId,
          data: params,
        });
      }
    } else {
      if (params && isObj) {
        jsonStr = JSON.stringify(params)
      }
    }
    try {
      if (jsonStr) {
        window.Android[method](jsonStr)
      } else {
        window.Android[method]()
      }
    } catch (e) {
      return Promise.reject(e);
    }
  }
  return p
}
